import { GroupsRounded, HomeRounded, MonetizationOnRounded, SendTimeExtensionRounded, SimCardDownloadRounded, SupervisorAccount } from "@mui/icons-material";
import { ReactElement } from "react";

export interface INavDrawerItem {
  nav: string;
  text: string;
  icon?: ReactElement<any, any>;
  expandByDefault?: boolean;
  children?: INavDrawerItem[];
  hideWhenNotSignedIn?: boolean;
  disableWhenNotSignedIn?: boolean;
  hideWhenNotTelephone?: boolean;
  hideWhenNotDOAAdmin?: boolean;
  hideWhenNonVancouverUser?: boolean;
  hideWhenNotLines?: boolean;
  name?: string;
  relatedRotes?: string[];
}

export const navigation: INavDrawerItem[] = [
  { nav: '/', text: 'Home', icon: <HomeRounded className="menu-icon" /> },
  {
    nav: '#',
    text: 'DOA Admin',
    expandByDefault: true,
    icon: <SupervisorAccount className="menu-icon" />,
    hideWhenNotDOAAdmin: true,
    hideWhenNotSignedIn: true,
    children: [
      { nav: '/doa-forecast', text: 'Forecast Report' },
      { nav: '/availability-administration-shifts', text: 'Availability Administration' },
      { nav: '/union-audit-report', text: 'Union Audit Report' },
      { nav: '/casual-audit-report', text: 'Casual Audit Report' },
      { nav: '/gang-way-report', text: 'Gangway Report' },
      { nav: '/dispatch-availability-list-report', text: 'Dispatch Availability List' },
    ]
  },
  {
    nav: '#',
    text: 'Dispatch',
    icon: <SendTimeExtensionRounded className="menu-icon" />,
    expandByDefault: true,
    children: [
      { nav: '/current-dispatch', text: 'My Current Dispatch', disableWhenNotSignedIn: true },
      { nav: '/current-lines-dispatch', text: 'My Current Lines Dispatch', disableWhenNotSignedIn: true, hideWhenNotLines: true },
      { nav: '/dispatch-history', text: 'My Dispatch History', hideWhenNotSignedIn: true },
      { nav: '/vessel-forecast', text: 'View Vessel Forecast', disableWhenNotSignedIn: true },
      { nav: '/doa-forecast', text: 'Declaration of Availability', hideWhenNotDOAAdmin: false },
      { nav: '/union-board', text: 'Union Boards', hideWhenNotSignedIn: true, hideWhenNonVancouverUser: true },
      { nav: '/casual-board', text: 'Casual Boards', hideWhenNotSignedIn: true, hideWhenNonVancouverUser: true },
      { nav: '/telephone-board/fa', text: 'First Aid Telephone Board', hideWhenNotSignedIn: true, name: "FA", hideWhenNonVancouverUser: true },
      { nav: '/telephone-board/sq', text: 'Squamish Telephone Board', hideWhenNotSignedIn: true, name: "SQ", hideWhenNonVancouverUser: true },
      { nav: '/telephone-board/ckd', text: 'Dock Checkers Telephone Board', hideWhenNotSignedIn: true, name: "CKD", hideWhenNonVancouverUser: true },
      { nav: '#', text: 'Telephone Boards', hideWhenNotSignedIn: true, hideWhenNotTelephone: true },
      { nav: '/work-info/vancouver', text: 'Work Information', relatedRotes: ['/work-info/squamish', '/work-info/coastwise'] },
      { nav: '/gang-work-info', text: 'Gang Work' },
      { nav: '/lines-work-info', text: 'Lines Work' },
      { nav: '/buttons', text: 'Buttons' },
      { nav: '/hall-chalk-boards', text: 'Hall Chalk Boards', hideWhenNotSignedIn: true, hideWhenNonVancouverUser: true },
      // TODO: This work is complete but is planned for V2 (or develop, after V1 has stabilized).
      //{ nav: '/hall-chalk-boards-new', text: 'Hall Chalk Boards (New)', hideWhenNotSignedIn: true, hideWhenNonVancouverUser: true },
    ]
  },
  {
    nav: '#',
    text: 'Training',
    icon: <GroupsRounded className="menu-icon" />,
    disableWhenNotSignedIn: false,
    children: [
      { nav: '/training-history', text: 'My Training History', hideWhenNotSignedIn: true },
      { nav: `/jda-reports`, text: 'JDA Reports' },
    ],
  },
  {
    nav: '#',
    text: 'Payroll',
    icon: <MonetizationOnRounded className="menu-icon" />,
    disableWhenNotSignedIn: true,
    children: [
      { nav: '/payroll-history', text: 'My Payroll History' }
    ],
  },
  {
    nav: '/downloadable-forms',
    text: 'Downloadable Forms',
    icon: <SimCardDownloadRounded className="menu-icon" />,
    disableWhenNotSignedIn: true,
  },
]

export enum TelephoneBoards {
  "First Aid" = "FA",
  Squamish = "SQ",
  "Dock Checkers" = "CKD",
}

export const COMPLEX_NAV_TITLES = [
  'union-board',
  'casual-board',
  'hall-chalk-boards',
  'hall-chalk-boards-new',
  'buttons',
  'work-info/vancouver',
  'work-info/squamish',
  'work-info/coastwise'
];